import React from 'react';
import { HashTagContent } from '@typings/hashtag';
import cls from 'classnames';
import { I18n } from '@ies/starling_intl';
import { formatNumber } from 'utils/format';
import style from './style.scss';
interface Props {
  element: HashTagContent;
}

export default function BasicInfo(props: Props) {
  const { element } = props;
  return (
    <div className={cls(style.column, style.info)}>
      <div className={style.place} />

      <div className={style.header}>
        <img src={element.cover_url} className={style.cover} />
        <div className={style.wrap}>
          <div className={style.section}>
            <span className={style.count}>{formatNumber(element.usage_amount)}</span>
            <span className={style.message}>{I18n.t('uses')}</span>
          </div>
          <div className={style.line} />
          <div className={style.section}>
            <span className={style.count}>{formatNumber(element.content_count)}</span>
            <span className={style.message}>{I18n.t('templates')}</span>
          </div>
        </div>
      </div>
      <div className={style.place} />
    </div>
  );
}
